// تصویری که داخل لینکِ دارای متن است و alt آن همان متن لینک است، برای screen reader دو بار خوانده
// می‌شود (Lighthouse: image-redundant-alt). تیم محتوا معمولاً alt را همان عنوان می‌گذارد؛ در این حالت
// تصویر تزئینی حساب می‌شود و alt خالی می‌گیرد. alt متفاوت دست نمی‌خورد.
const normalize = (value) => (typeof value === "string" ? value.replace(/\s+/g, " ").trim() : "");

export const alt_unless_repeated = (alt, text) => {
    const clean_alt = normalize(alt);
    if (!clean_alt) return "";
    return clean_alt === normalize(text) ? "" : alt;
};
